export default __webpack_public_path__ + "static/media/siteweb.a78401c1.png";